// ===== LANDING PAGE ENGINE — CONFIGURAÇÃO DAS PÁGINAS SEGMENTADAS =====
// Para criar uma nova landing (ex: /50-mais, /nutricao, /hipertrofia):
// 1. Adicione uma entrada aqui  2. Registre a rota em App.js  3. Pronto.

export const GOAL_CARDS = [
  { icon: "flame", label: "Emagrecer", href: "/emagrecer" },
  { icon: "dumbbell", label: "Ganhar massa", href: "/treino" },
  { icon: "weight", label: "Melhorar o treino", href: "/treino" },
  { icon: "salad", label: "Organizar a alimentação", href: "/emagrecer" },
  { icon: "sparkles", label: "Ter acompanhamento com IA", href: "/coach-ia" },
  { icon: "heart", label: "Criar hábitos melhores", href: "/mulher" },
];

export const LANDINGS = {
  emagrecer: {
    slug: "emagrecer",
    landingId: "landing_emagrecer",
    accent: "brand",
    seo: {
      title: "Emagrecimento com treino e alimentação | TryVitta",
      description:
        "Treinos personalizados, alimentação organizada, acompanhamento da evolução e Coach IA para ajudar você a emagrecer com consistência. 5 dias grátis.",
    },
    hero: {
      badge: "Emagrecimento",
      title: "Emagrecer não precisa ser",
      titleAccent: "complicado.",
      sub: "Tenha treino, alimentação, acompanhamento e inteligência artificial trabalhando juntos para ajudar você a chegar ao seu objetivo.",
      cta: "Começar grátis",
    },
    heroShot: "/assets/screens/slim-painel.webp",
    featuresTitle: "Um plano pensado para você",
    features: [
      { icon: "dumbbell", title: "Treinos personalizados", text: "Montados para o seu corpo, seu nível e a sua semana." },
      { icon: "salad", title: "Estratégias de alimentação", text: "Cardápio gerado por IA que cabe na sua rotina — sem terrorismo nutricional." },
      { icon: "trendingDown", title: "Acompanhamento da evolução", text: "Você enxerga cada quilo a menos e cada semana de constância." },
      { icon: "scale", title: "Controle de peso", text: "Registre e acompanhe seu peso sem obsessão, com contexto." },
      { icon: "target", title: "Metas", text: "Objetivos claros por semana para você saber exatamente o que fazer." },
      { icon: "calendarCheck", title: "Hábitos", text: "Check-in diário de 30 segundos que mantém sua jornada viva." },
      { icon: "sparkles", title: "Coach com IA", text: "Conversa, cobra e celebra com você — todos os dias." },
    ],
    flow: {
      title: "Seu processo de emagrecimento em um só lugar",
      steps: [
        "Defina seu objetivo",
        "Conheça seu plano",
        "Treine",
        "Organize sua alimentação",
        "Acompanhe sua evolução",
      ],
    },
    objection: {
      title: "Não precisa ser perfeito. Precisa ser consistente.",
      text: "O TryVitta acompanha o seu ritmo: sem culpa, sem dietas impossíveis. Um dia de cada vez, com o coach ao seu lado.",
    },
    screens: [
      { src: "/assets/screens/slim-painel.webp", caption: "Painel diário de emagrecimento" },
      { src: "/assets/screens/slim-evolucao.webp", caption: "Evolução de peso em gráfico" },
      { src: "/assets/screens/analise-evolucao.webp", caption: "Sua evolução em detalhes" },
    ],
    faq: [
      { q: "O TryVitta substitui um nutricionista?", a: "Não. O TryVitta é um acompanhamento complementar do dia a dia. Se você tem nutricionista, o plano dele pode ser seguido dentro do app." },
      { q: "Preciso ir à academia?", a: "Não. O app monta treinos para casa e para academia — você escolhe onde treinar." },
      { q: "Posso usar em casa?", a: "Pode. Treinos em casa sem equipamento, cardápio simples e acompanhamento completo pelo celular." },
      { q: "Como funciona o teste grátis?", a: "Você tem 5 dias de acesso completo, sem cartão. Depois, escolhe o plano que fizer sentido — e pode cancelar em 2 toques." },
      { q: "Como acompanho minha evolução?", a: "Com painel diário, gráfico de peso, check-ins e relatório semanal inteligente dentro do app." },
    ],
    finalCta: {
      title: "Seu emagrecimento começa com o primeiro dia.",
      sub: "Descubra sua jornada personalizada em menos de 60 segundos.",
      cta: "Começar grátis",
    },
  },

  treino: {
    slug: "treino",
    landingId: "landing_treino",
    accent: "brand",
    seo: {
      title: "Treinos personalizados para academia | TryVitta",
      description:
        "Treinos organizados por nível e objetivo, com séries, cargas, histórico e evolução registrados. Saiba exatamente o que fazer em cada sessão. 5 dias grátis.",
    },
    hero: {
      badge: "Treinos",
      title: "Pare de treinar sem saber",
      titleAccent: "o que fazer.",
      sub: "Tenha seus treinos organizados, acompanhe sua evolução e saiba exatamente o que fazer em cada sessão.",
      cta: "Montar meu treino",
    },
    heroShot: "/assets/screens/treino-execucao.webp",
    featuresTitle: "Tudo que seu treino precisa",
    features: [
      { icon: "clipboard", title: "Treinos organizados", text: "Cada sessão pronta antes de você chegar na academia." },
      { icon: "play", title: "Exercícios demonstrados", text: "Vídeo e execução guiada para treinar com segurança." },
      { icon: "listChecks", title: "Séries e repetições", text: "Tudo contado para você: séries, reps e descanso." },
      { icon: "dumbbell", title: "Controle de carga", text: "Registre cargas e veja sua progressão semana a semana." },
      { icon: "history", title: "Histórico", text: "Cada treino fica salvo — sua evolução vira um arquivo vivo." },
      { icon: "trendingUp", title: "Evolução", text: "Gráficos e recordes que mostram que você está avançando." },
      { icon: "barChart", title: "Diferentes níveis", text: "Do primeiro dia na academia ao treino avançado." },
      { icon: "target", title: "Objetivos diferentes", text: "Emagrecimento, hipertrofia, definição ou condicionamento." },
    ],
    choiceGrids: [
      { title: "Escolha seu nível", cards: ["Iniciante", "Intermediário", "Avançado"] },
      { title: "Escolha seu objetivo", cards: ["Emagrecimento", "Hipertrofia", "Definição", "Condicionamento"] },
    ],
    screens: [
      { src: "/assets/screens/treinos.webp", caption: "Seus treinos da semana" },
      { src: "/assets/screens/treino-execucao.webp", caption: "Série, carga e descanso guiados" },
      { src: "/assets/screens/treino-personal.webp", caption: "Treino montado por personal" },
    ],
    faq: [
      { q: "Preciso ter experiência na academia?", a: "Não. O TryVitta tem níveis do iniciante ao avançado, com execução guiada de cada exercício." },
      { q: "Funciona para treinar em casa?", a: "Sim. Você escolhe onde treina e o app adapta o plano — com ou sem equipamento." },
      { q: "Como sei qual carga usar?", a: "O app sugere cargas iniciais e você registra cada sessão; a progressão aparece no seu histórico." },
      { q: "Meu personal pode montar meu treino no app?", a: "Pode. Profissionais usam o TryVitta Pro para prescrever e acompanhar seus alunos." },
      { q: "Como funciona o teste grátis?", a: "5 dias de acesso completo, sem cartão. Cancele quando quiser, direto no app." },
    ],
    finalCta: {
      title: "Seu próximo treino já pode ter um plano.",
      sub: "Responda algumas perguntas e receba sua jornada de treino.",
      cta: "Começar meu treino",
    },
  },

  mulher: {
    slug: "mulher",
    landingId: "landing_mulher",
    accent: "rose",
    seo: {
      title: "Treino e alimentação para mulheres | TryVitta",
      description:
        "Uma experiência pensada para a rotina feminina: treino, nutrição, emagrecimento, ciclo menstrual integrado e Coach IA. 5 dias grátis.",
    },
    hero: {
      badge: "TryVitta Femme",
      title: "Um plano feito para a mulher que quer",
      titleAccent: "cuidar de si.",
      sub: "Treino, alimentação, evolução e acompanhamento em uma experiência pensada para a rotina feminina.",
      cta: "Conhecer o TryVitta Femme",
    },
    heroShot: "/assets/screens/home-feminina.webp",
    featuresTitle: "Feito para a sua rotina",
    features: [
      { icon: "dumbbell", title: "Treinos", text: "Para casa ou academia, no seu ritmo e no seu tempo." },
      { icon: "salad", title: "Nutrição", text: "Cardápio personalizado que respeita seu paladar e sua rotina." },
      { icon: "flame", title: "Emagrecimento", text: "Jornada Slim com painel diário e evolução em gráfico." },
      { icon: "trendingUp", title: "Evolução", text: "Você acompanha cada conquista, sem neura com a balança." },
      { icon: "calendarHeart", title: "Ciclo menstrual", text: "Exclusivo: treino e dieta adaptados a cada fase do seu ciclo.", exclusive: true },
      { icon: "sparkles", title: "Coach IA", text: "Uma companhia diária que entende seus dias bons e difíceis." },
    ],
    transformGrid: {
      title: "Escolha o que você quer transformar",
      cards: ["Emagrecer", "Definir", "Ganhar massa", "Melhorar o condicionamento", "Criar uma rotina saudável"],
    },
    screens: [
      { src: "/assets/screens/home-feminina.webp", caption: "Sua jornada, do seu jeito" },
      { src: "/assets/screens/ciclo-menstrual.webp", caption: "Treino e dieta por fase do ciclo" },
      { src: "/assets/screens/mind.webp", caption: "TryVitta Mind: mente e sono" },
    ],
    faq: [
      { q: "O app se adapta ao meu ciclo menstrual?", a: "Sim — e isso é exclusivo do TryVitta: treino e dieta ajustados para cada fase do ciclo." },
      { q: "Serve para quem está começando do zero?", a: "Com certeza. O plano começa no seu nível e evolui com você, sem cobranças impossíveis." },
      { q: "Posso treinar em casa?", a: "Pode. Treinos para casa, academia ou os dois — você escolhe a cada dia." },
      { q: "Tem conteúdo de bem-estar?", a: "Sim: o TryVitta Mind tem meditações guiadas, respiração e sons para dormir melhor." },
      { q: "Como funciona o teste grátis?", a: "5 dias de acesso completo, sem cartão. Cancele quando quiser, direto no app." },
    ],
    finalCta: {
      title: "Cuidar de você também é prioridade.",
      sub: "Descubra sua jornada em menos de 60 segundos.",
      cta: "Conhecer o TryVitta Femme",
    },
  },

  glp1: {
    slug: "glp1",
    landingId: "landing_glp1",
    accent: "brand",
    seo: {
      title: "Organize sua rotina de treino e alimentação | TryVitta",
      description:
        "Para quem usa GLP-1: organize treino, alimentação, hábitos e acompanhamento da evolução em um só lugar. Acompanhamento complementar. 5 dias grátis.",
    },
    hero: {
      badge: "Jornada GLP-1",
      title: "Seu processo de emagrecimento mudou. Seu planejamento também",
      titleAccent: "precisa mudar.",
      sub: "Organize treino, alimentação, hábitos e acompanhamento da sua evolução em um único lugar.",
      cta: "Conhecer o TryVitta",
    },
    heroShot: "/assets/screens/slim-care.webp",
    featuresTitle: "Mais do que perder peso",
    features: [
      { icon: "salad", title: "Alimentação organizada", text: "Cardápio estruturado com atenção à proteína do seu dia." },
      { icon: "dumbbell", title: "Treinamento", text: "Treinos adaptados para preservar massa muscular no processo." },
      { icon: "calendarCheck", title: "Hábitos", text: "Check-in diário de humor, fome, saciedade e disposição." },
      { icon: "trendingDown", title: "Registro de evolução", text: "Sua trajetória registrada dia após dia, em gráficos claros." },
      { icon: "scale", title: "Peso", text: "Acompanhamento do peso com contexto, sem paranoia." },
      { icon: "ruler", title: "Medidas", text: "Registre medidas e fotos para enxergar o que a balança não mostra." },
      { icon: "repeat", title: "Rotina", text: "Estrutura para os dias bons e para os difíceis." },
      { icon: "heartHandshake", title: "Acompanhamento", text: "Assistente Care conversando com você em toda a jornada." },
    ],
    glp1Note: {
      title: "Usa medicamentos GLP-1?",
      text: "O Modo Canetinha do TryVitta Slim ajuda você a registrar sintomas, manter hábitos e organizar sua rotina — sempre com seu médico conduzindo o tratamento.",
    },
    disclaimer:
      "O TryVitta não substitui acompanhamento médico ou nutricional. Nunca altere doses ou tratamentos por conta própria.",
    screens: [
      { src: "/assets/screens/slim-painel.webp", caption: "Painel diário completo" },
      { src: "/assets/screens/slim-care.webp", caption: "Assistente Care na jornada" },
      { src: "/assets/screens/slim-evolucao.webp", caption: "Evolução em gráfico" },
    ],
    faq: [
      { q: "O TryVitta é um tratamento para emagrecimento?", a: "Não. O TryVitta é uma ferramenta de organização de rotina — treino, alimentação e hábitos. Tratamentos são conduzidos por médicos." },
      { q: "Posso usar junto com meu acompanhamento médico?", a: "Sim, e recomendamos. O app complementa o acompanhamento profissional organizando seu dia a dia." },
      { q: "O app indica doses ou medicamentos?", a: "Nunca. O TryVitta não prescreve, não indica doses e não orienta tratamentos. Isso é papel exclusivo do seu médico." },
      { q: "E se eu não usar medicamento?", a: "O TryVitta Slim funciona da mesma forma: é uma jornada completa de emagrecimento com hábitos, nutrição e bem-estar." },
      { q: "Como funciona o teste grátis?", a: "5 dias de acesso completo, sem cartão. Cancele quando quiser, direto no app." },
    ],
    finalCta: {
      title: "Organização é metade da jornada.",
      sub: "Monte sua rotina personalizada em menos de 60 segundos.",
      cta: "Conhecer o TryVitta",
    },
  },

  "coach-ia": {
    slug: "coach-ia",
    landingId: "landing_coach_ia",
    accent: "brand",
    seo: {
      title: "Coach fitness com inteligência artificial | TryVitta",
      description:
        "8 coaches com IA que conversam por texto e voz, analisam fotos do seu prato e organizam sua rotina de treino e alimentação. 5 dias grátis.",
    },
    hero: {
      badge: "Coach com IA",
      title: "E se você tivesse um coach disponível",
      titleAccent: "quando precisasse?",
      sub: "O TryVitta usa inteligência artificial para ajudar você a organizar sua rotina de treino, alimentação e evolução.",
      cta: "Experimentar grátis",
    },
    heroShot: "/assets/screens/coach-maya.webp",
    examples: {
      title: "Pergunte qualquer coisa",
      items: [
        "Qual treino faço hoje?",
        "O que posso comer no jantar?",
        "Como organizar minha semana?",
        "Estou evoluindo?",
        "Como manter minha rotina?",
      ],
    },
    explainer: {
      title: "IA + seus dados + sua rotina",
      text: "O coach usa as informações que você compartilha — suas respostas, seus registros e sua rotina — para deixar as orientações cada vez mais suas. Nada genérico.",
      cards: [
        { icon: "message", title: "Suas respostas", text: "O coach entende seu objetivo e seus desafios." },
        { icon: "calendarCheck", title: "Sua rotina", text: "Treinos, refeições e check-ins dão contexto." },
        { icon: "trendingUp", title: "Sua evolução", text: "As orientações se ajustam conforme você avança." },
      ],
      note: "A IA do TryVitta é um acompanhamento diário e não substitui profissionais de saúde.",
    },
    featuresTitle: "Um time de coaches no seu bolso",
    features: [
      { icon: "users", title: "8 coaches com personalidade", text: "Maya, Vitto, Vivi, Theo, Sofi, Cadu... escolha o seu e troque quando quiser." },
      { icon: "mic", title: "Voz e texto", text: "Converse como preferir, a qualquer hora do dia." },
      { icon: "camera", title: "Análise por foto", text: "Foto do prato, do treino ou do look — feedback na hora." },
    ],
    screens: [
      { src: "/assets/screens/coach-maya.webp", caption: "Coach analisando sua refeição" },
      { src: "/assets/screens/analise-corporal.webp", caption: "Análise corporal por foto" },
      { src: "/assets/screens/diario.webp", caption: "Diário de emoções e energia" },
    ],
    faq: [
      { q: "O coach de IA substitui profissionais de saúde?", a: "Não. Ele é um acompanhamento diário complementar. Médico, nutricionista e personal continuam essenciais." },
      { q: "Posso conversar por voz?", a: "Pode. O coach conversa por texto e por voz, como for mais confortável para você." },
      { q: "Como funciona a análise por foto?", a: "Você envia a foto do prato, do treino ou do look e a IA responde na hora, em linguagem simples." },
      { q: "Posso trocar de coach?", a: "Sim, quando quiser. Cada coach tem personalidade e estratégia diferentes." },
      { q: "Como funciona o teste grátis?", a: "5 dias de acesso completo, sem cartão. Cancele quando quiser, direto no app." },
    ],
    finalCta: {
      title: "Seu coach já está esperando.",
      sub: "Descubra sua jornada personalizada em menos de 60 segundos.",
      cta: "Experimentar grátis",
    },
  },
};
